// String must contain only letters, digits, underscores, and at least one letter
export const communityHandleRegex = new RegExp(/^(?=.*[a-zA-Z])[a-zA-Z0-9_]+$/);